import { render } from "./StoreNavigation.vue?vue&type=template&id=f2164368"
import script from "./StoreNavigation.vue?vue&type=script&lang=js"
export * from "./StoreNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__